module.exports = __webpack_public_path__ + "img/default.226c87d6.png";